exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.control-label[data-v-446b430a] {\n  font-weight: bold;\n  margin-bottom: 0;\n}\n.last-modified-row[data-v-446b430a] {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n", ""]);

// exports
